import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { adoptSolarIncentives } from "./solar-incentive-dependents"
import type { SolarProposalIncentivesDto } from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Refresh incentives: asks the provider again and answers with the catalog. */
export default function useRefreshSolarProposalIncentives(): UseMutationResult<
  SolarProposalIncentivesDto,
  unknown,
  { proposalId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId }) =>
      solarProposalService.refreshIncentives(proposalId),
    onSuccess: (incentives, { proposalId }) => {
      adoptSolarIncentives(queryClient, proposalId, incentives)
    },
  })
}
